import projectService from "../../services/projectService";

const state = {
  projects: [],
  projectStakeholdersWithSurveys: [],
  projectConversations: [],
  filteredProjects: [],
  selectedProject: null,
};

const getters = {
  projects: state => {
    return state.projects;
  }
};

const actions = {
  async getProjects({ commit }) {
    let projects = await projectService.fetchProjects();
    commit("SET_PROJECTS", projects.data);
    return projects
  },
  updateSelectedProject({ commit }, project) {
    commit("UPDATE_SELECTED_PROJECT", project);
  },
  filterProjects({ commit }, filteredProjects) {
    commit("FILTER_PROJECTS", filteredProjects);
  },
  async getProjectStakeholdersWithSurveys({ commit }, pk) {
    await projectService.getProjectStakeholdersWithSurveys(pk).then(response => {
      commit("SET_PROJECT_STAKEHOLDERS_WITH_SURVEYS", response.data)
    }).catch(() => {
      commit("SET_PROJECT_STAKEHOLDERS_WITH_SURVEYS", { stakeholders: "Error", surveys: "Error" } )
    })
  },
  async getProjectConversations({ commit }, pk) {
    await projectService.getProjectConversations(pk).then(response => {
      commit("SET_PROJECT_CONVERSATIONS", response.data)
    }).catch(() => {
      commit("SET_PROJECT_CONVERSATIONS", { conversations: "Error", percentage: "Error" } )
    })
  }
}

const mutations = {
  SET_PROJECTS(state, response) {
    state.projects = response;
  },
  UPDATE_SELECTED_PROJECT(state, selectedProject) {
    state.selectedProject = selectedProject;
  },
  FILTER_PROJECTS(state, filteredProjects) {
    state.filteredProjects = filteredProjects;
  },
  SET_PROJECT_STAKEHOLDERS_WITH_SURVEYS(state, response) {
    state.projectStakeholdersWithSurveys = response;
  },
  SET_PROJECT_CONVERSATIONS(state, response) {
    state.projectConversations = response;
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};
